import { AxiosError } from 'axios';
import { useMutation, useQueryClient } from 'react-query';

import { usePageVisibility } from '../../../common/usePageVisibility';
import { api } from '../../../utils/api-client';
import { useGetFetch } from '../../../utils/reactQuery';
import { ApiRoutesEnum } from '../../../utils/routes';
import { MATCHING_QUERY_KEY } from '../useMatchingRead';

import { MatcherStatus, MatchingSettings } from './matchingAdmin.types';

const statusKey = [ApiRoutesEnum.getMatchingStatus, undefined];

export const useMatchingAdmin = () => {
  const visible = usePageVisibility();
  const client = useQueryClient();
  const save = useMutation<MatchingSettings, AxiosError, MatchingSettings>(
    async (settings) => (await api.patch<MatchingSettings>(ApiRoutesEnum.updateMatchingSettings, settings)).data,
    {
      onMutate: () => client.cancelQueries(statusKey),
      onSuccess: (settings) => {
        client.setQueryData<MatcherStatus | undefined>(statusKey, (old) => (old ? { ...old, settings } : undefined));
        client.invalidateQueries(statusKey);
        client.invalidateQueries([MATCHING_QUERY_KEY]);
      },
    }
  );
  const status = useGetFetch<MatcherStatus>({
    url: ApiRoutesEnum.getMatchingStatus,
    config: {
      enabled: visible && !save.isLoading,
      refetchInterval: (_data, query) => (query.state.error ? false : 10000),
      refetchIntervalInBackground: false,
    },
  });
  return { status, save };
};
